module.exports = __webpack_public_path__ + "static/media/icon-customer.cd48f20e.png";